import { render, staticRenderFns } from "./Downloads.vue?vue&type=template&id=3c9609e6"
import script from "./Downloads.vue?vue&type=script&lang=js"
export * from "./Downloads.vue?vue&type=script&lang=js"
import style0 from "./Downloads.vue?vue&type=style&index=0&id=3c9609e6&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports